/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateRackPlaceRequest } from './create-rack-place-request';


export interface CreateRackShelfRequest { 
    name: string;
    number: number;
    socketTypeId: number;
    places?: Array<CreateRackPlaceRequest> | null;
}

